__webpack_require__.p = "/shop-app/";